module.exports = __webpack_public_path__ + "img/warning-icon.4c2f8165.png";